import { Backdrop, Box, Button, Fade, Grid, Modal, Typography } from "@mui/material"
import { TicketLocal } from "../../../../../hooks/sendPrint";
import { exportToExcel } from "react-json-to-excel";

const style = {
  position: "absolute",
  top: "35%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 500,
  maxWidth: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  display: "flex",
  justifyContent: "center",
};

export const ModalConfirmacionTag = ({ open, setOpen, dataReprint, onClose, revertData }) => {

  const { ticketLocalMutation } = TicketLocal();

  const reprint = async () => {
    for (let print of dataReprint) {
      await new Promise((resolve, reject) => {
        ticketLocalMutation(print, {
          onSuccess: (response) => {
            console.log(response);
            resolve(); // Solo avanza cuando se complete esta petición
          },
          onError: (error) => {
            console.log(error);
            reject(error); // Detiene la secuencia si hay error
          },
        });
      });
    }
  }

  const export_excel = () => {
    let data_excel = dataReprint.map((data) => {
      return {
        etiqueta: data?.tag_code,
        almacenEnvio: data?.almacen
      }
    })
    console.log(data_excel)
    exportToExcel(
      data_excel,
      `galus_etiquetas_impresion_tardia`
    )
  }

  const revertir = () => {
    if(revertData){
      revertData();
    }else{
      export_excel()
    }
  }


  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style} className="modal_confirm_tag">
          <Grid container spacing={0}>
            <Grid item xs={12} sx={{ p: 0, mb: 3, pr: 1 }} className="center_item">
              <Typography id="transition-modal-title" variant="h6" component="h2">
                Confirmación de impresión
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ p: 0, mb: 2, pr: 1 }} className="center_item">
              <span style={{ fontSize: 16, textAlign: 'center' }}>
                Verifique que todas las impresiones de etiquetas se hayan realizado correctamente para continuar
              </span>
            </Grid>
            <Grid item xs={12} sx={{ p: 0, mb: 2, pr: 1 }} className="center_item">
              <span style={{ fontSize: 16, textAlign: 'center' }}>
                En caso de algún error de impresión fuera del sistema, puede seleccionar <span style={{ textDecorationLine: 'underline' }}>reimprimir</span> para volver a enviar la orden de impresion del paquete de etiquetas
              </span>
            </Grid>
            <Grid item xs={12} sx={{ p: 0, mb: 3, pr: 1 }} className="center_item">
              <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap:25 }}>
                <Button
                  variant="contained"
                  className="btn_system"
                  sx={{ p: '0px 5px' }}
                  disableElevation
                  onClick={reprint}
                >
                  Reimprimir
                </Button>
                <Button
                  variant="outlined"
                  className="btn_system"
                  sx={{ p: '0px 5px' }}
                  disableElevation
                  onClick={onClose}
                >
                  Continuar
                </Button>
              </div>
            </Grid>
            <Grid item xs={12} sx={{ p: 0, mb: 2, pr: 1 }} className="center_item">
              <span style={{ fontSize: 16, textAlign: 'center' }}>
                También puede revertir los cambios realizados en el sistema si hubo un error en la generación de las etiquetas
              </span>
            </Grid>
            <Grid item xs={12} sx={{ p: 0, mb: 1, pr: 1 }} className="center_item">
              <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: 4 }}>
                <Button
                  variant="outlined"
                  className="btn_system"
                  sx={{ p: '0px 5px' }}
                  disableElevation
                  onClick={revertir}
                >
                  Revertir cambios
                </Button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  )
}